import React, { useMemo, useState } from "react";
import { ReactComponent as AlterPassword } from "assets/icons/alter-password.svg";
import { ReactComponent as LogoutIcon } from "assets/icons/logout-icon.svg";
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from "react-icons/md";
import { ReactComponent as ProfileIcon } from "assets/icons/profile-icon.svg";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import Avatar from "components/MI/Avatar";
import DropdownWrapper from "components/layout/DropdownWrapper";
import { signOut } from "utils/functions";

import TourBalloon from "components/NewTour/TourBallon";
import {
  AccountContainer,
  AvatarContainer,
  Container,
  ContainerWrap,
  DropdownItem,
  DropdownMenu,
  DropdownText,
  Icon,
  IconContainer,
  InfoContainer,
  Subtitle,
  TextWrap,
  Title,
} from "./styles";
import { useTour } from "hooks/useTour";

const UserMenuIcon = (): JSX.Element => {
  const [show, setShow] = useState(false);
  const selectedUnit = useSelector(
    // @ts-ignore
    (state) => state.selectUnitReducer.selectedUnit
  );
  const userName = localStorage.getItem("@UltragazEmpresarial:userName");

  const history = useHistory();

  const { showTour, tourStep, tourType } = useTour();

  const name = useMemo(() => {
    const nameSplit = userName?.split(" ");
    return `${nameSplit[0] ?? ""} ${nameSplit[1] ?? ""}`;
  }, [userName]);

  const toggleShow = (): void => {
    setShow((prevState) => !prevState);
  };

  return (
    <ContainerWrap>
      <Container showTour={showTour && tourType === "home" && tourStep === 3}>
        <AccountContainer onClick={toggleShow}>
          <AvatarContainer>
            <Avatar />
          </AvatarContainer>
          <InfoContainer>
            <Title>{name}</Title>
            <Subtitle>
              {selectedUnit?.hasCurrentHouseholder
                ? "Morador Atual"
                : "Morador Antigo"}
            </Subtitle>
          </InfoContainer>
          <IconContainer>
            {show ? (
              <MdOutlineKeyboardArrowUp />
            ) : (
              <MdOutlineKeyboardArrowDown />
            )}
          </IconContainer>
        </AccountContainer>
        {show && (
          <DropdownWrapper hideDropdown={toggleShow}>
            <DropdownMenu>
              <DropdownItem onClick={() => history?.push("/meus-dados-novo")}>
                <Icon>
                  <ProfileIcon width={22} height={22} />
                </Icon>
                <TextWrap>
                  <DropdownText>Meu perfil</DropdownText>
                </TextWrap>
              </DropdownItem>
              <DropdownItem onClick={() => history?.push("/alterar-senha")}>
                <Icon>
                  <AlterPassword width={22} height={22} />
                </Icon>
                <TextWrap>
                  <DropdownText>Alterar senha</DropdownText>
                </TextWrap>
              </DropdownItem>
              <DropdownItem onClick={() => signOut()}>
                <Icon>
                  <LogoutIcon width={22} height={22} />
                </Icon>
                <TextWrap>
                  <DropdownText>Sair</DropdownText>
                </TextWrap>
              </DropdownItem>
            </DropdownMenu>
          </DropdownWrapper>
        )}
      </Container>
      {showTour && tourType === "home" && tourStep === 3 && (
        <TourBalloon
          title="Opções do perfil"
          content="Aqui você pode alterar seus dados e visualizar as informações cadastrais. Também é possível alterar sua senha de acesso ao portal."
          position={{
            left: "50%",
            right: "0",
            top: "52px",
            arrowPosition: "top",
            maxWidth: "unset",
            transform: "translateX(-50%)",
            width: "220px",
          }}
        />
      )}
    </ContainerWrap>
  );
};

export default UserMenuIcon;
